import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { hash } from 'rsvp';

export default class CourseEditorRoute extends Route 
{
	@service store;
	
	model(params) 
	{
		var event = this.modelFor("event");
	   	return hash(
		{
			event: event,
			course: this.store.findRecord('Course', params.course_id)
		});
	}
}
